<template>
    <MainContent title="Detalles de la importación">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center w-100 mb-3">
                <h3 class="card-title pt-2 mb-0">Detalles de la importación</h3>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="loading" class="text-center my-5">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="mt-3">Cargando...</p>
            </div>
            
            <div v-else>
                <div class="card mb-4">
                    <div class="card-header">
                        <h5 class="mb-0">Información general</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <p><strong>Nombre del archivo:</strong> {{ importacion.data?.nombre_archivo }}</p>
                                <p><strong>Fecha de importación:</strong> {{ importacion.data?.created_at }}</p>
                            </div>
                            <div class="col-md-6">
                                <p><strong>Estado:</strong> 
                                    <b-alert v-if="importacion.data?.estado_importacion" 
                                             show 
                                             :variant="getEstadoVariant(importacion.data.estado_importacion)" 
                                             class="d-inline-block p-1 ml-2 mb-0"
                                    >
                                        <i :class="getEstadoIcon(importacion.data.estado_importacion)" class="mr-1"></i>
                                        {{ importacion.data?.estado_importacion_texto }}
                                    </b-alert>
                                </p>
                                <p><strong>ID:</strong> {{ importacion.data?.id }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="importacion.data?.detalles && importacion.data.detalles.length > 0" class="card">
                    <div class="card-header">
                        <h5 class="mb-0">Detalles de la importación</h5>
                    </div>
                    <div class="card-body">
                        <ContainerTable :data="importacion.data?.detalles" :responsive="esMovil">
                            <b-table 
                                hover 
                                :items="importacion.data?.detalles" 
                                :fields="fields" 
                                :busy="loading"
                                empty-text="No hay detalles disponibles para esta importación"
                            />
                        </ContainerTable>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>
<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from "@/components/backend/components/MainContent";
    import ContainerTable from '@/components/backend/common/ContainerTable';

    export default {
        components: {
            MainContent,
            ContainerTable
        },
        data() {
            return {
                loading: false,
                importacion: {},
                fields: [
                    { key: "email", label: "Email", sortable: true },
                    { key: "nombre", label: "Nombre", sortable: true },
                    { key: "estado", label: "Estado", sortable: true },
                    { key: "created_at", label: "Fecha", sortable: true }
                ]
            };
        },
        methods: {
            async getInportacionData(id) {
                this.loading = true;
                try 
                {
                    const response = await apiService.getImportacion(id);
                    this.importacion = response;
                } 
                catch (error) 
                {
                    this.$toast.error("Error al cargar la importación");
                } 
                finally 
                {
                    this.loading = false;
                }
            }
        },
        getEstadoVariant(estado) {
            switch(estado) {
                case '0': return 'warning';
                case '1': return 'info';
                case '2': return 'success';
                case '3': return 'danger';
                default: return 'secondary';
            }
        },   
        getEstadoIcon(estado) {
            switch(estado) {
                case '0': return 'fas fa-clock';
                case '1': return 'fas fa-spinner fa-spin';
                case '2': return 'fas fa-check-circle';
                case '3': return 'fas fa-times-circle';
                default: return 'fas fa-question-circle';
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        created() {
            const id = this.$route.params.id;
            if (id) {
                this.getInportacionData(id);
            } else {
                this.$toast.error("ID de importación no válido");
                this.$router.push({ name: 'back.emails.importaciones.index' });
            }
        }
    };
</script>

<style scoped>
.card {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header {
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.b-alert {
    display: inline-block;
}
</style>